export function isSSO(account: { authenticationSource: string }) {
  return account?.authenticationSource === 'okta';
}
